import ErrorPage from '@components/error-page'

const NotFound = () => {
  return (
    <ErrorPage message={'La page n\'existe pas'} title={'Page non trouvée'} />
  )
}

export default NotFound
